<template>
  <a-layout-content
    :style="{ padding: '0 0px', marginTop: '0px' ,background: '#eceff3' ,minHeight:'10px' }">
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol" @submit="handleSubmit">

      <div :style="{ background: '#fff', padding: '14px', minHeight: '200px' }">
        {{$t('message.transform.boundShop')}}
        <a-divider/>
        <template>
          {{$t('message.transform.selectShop')}}
          <a-form-item>

            <a-checkbox-group style="width: 300px" buttonStyle="outline" @change="onChange">

              <a-space direction="vertical" align="start">
                <a-row>
                  <a-col :offset="3">
                    <div v-for="item in this.shopList" :key="item.sellerCode" :value="item.shopName" justify="center"
                         :style="{ background: '#fff', padding: '14px', minHeight: '20px',}">
                      <div v-if="item.cb!==true&&item.platform!=='AEG'">
                        <a-checkbox style="width: 600px" :value="item.sellerCode" :key="item.sellerCode">
                          {{item.shopName+' ['+item.sellerCode+']'}}
                        </a-checkbox>
                      </div>
                      <div v-if="item.cb===true&&item.platform!=='AEG'">
                        <a-checkbox style="width: 600px" :value="item.sellerCode" :key="item.sellerCode" :disabled=true
                                    :autoFocus="true">
                          {{item.shopName+' ['+item.sellerCode+']'}}
                        </a-checkbox>
                      </div>
                      <br>
                    </div>
                  </a-col>
                </a-row>
              </a-space>
            </a-checkbox-group>
          </a-form-item>
        </template>
        <a-divider/>
        <p>{{$t('message.transform.record')}}</p>
        <template>
          <div style="margin-left: 50px; margin-right: 100px; margin-top: 50px; ">
            <a-descriptions title="">
              <a-descriptions-item :label="$t('message.transform.startTime')">
                {{this.lastBindRecord.beginTime}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.transform.isDone')">
                {{this.lastBindRecord.finish=== null ?'': (this.lastBindRecord.finish===true? $t('message.transform.finished'):$t('message.transform.unfinished'))}}
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.transform.isSuccess')">
                <span style="color:red">{{this.lastBindRecord.success=== null ? '': (this.lastBindRecord.success===true?$t('message.transform.success'):$t('message.transform.failed'))}}</span>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.transform.downloadErrorFileUrl')">
                <a :href="this.lastBindRecord.downloadErrorFileUrl===''?'':this.lastBindRecord.downloadErrorFileUrl"
                   download="transformError.xlsx">{{this.lastBindRecord.downloadErrorFileUrl===''?'':$t('message.transform.errorFile')}}</a>
              </a-descriptions-item>
              <a-descriptions-item :label="$t('message.transform.operateStore')">
                {{this.lastBindRecord.shopNames.toString().replace(/[\\]\\["]/g, '')}}
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </template>

        <a-divider/>
        <div justify="center" align="middle">
          <a-form-item>
            <a-space align="center">
              <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                <a-button type="primary" html-type="submit" :disabled="this.transformButtonValid">
                  {{$t('message.transform.startBind')}}
                </a-button>
              </a-form-item>
            </a-space>
          </a-form-item>
        </div>
      </div>
    </a-form>
    <div>
      <a-modal
        :closable="false"
        :title="$t('message.transform.startShopBindCheck')"
        :visible="modelShowChange.check"
        :confirm-loading="confirmLoading"
        :width="830"
        :okText="$t('message.transform.startShopBind')"
        :cancelText="$t('message.transform.cancel')"
        @ok="handleOk"
        :maskClosable="false"
        :okButtonProps="modelButtonProps"
        :cancelButtonProps="{props:{show:false}}"
        @cancel="handleCancel"
      >
        <div v-if="this.transformCheckBox.status==1">
          <template>
            <a-alert :message="$t('message.transform.check')" type="info" show-icon>
              <p slot="description" style="font-size: 6px">
                <span style="color: black; font-size: 3px"
                >{{$t('message.transform.mentionInfo')}}</span
                >
              </p>
            </a-alert>
          </template>
        </div>
        <div v-if="this.transformCheckBox.status == 2">
          <template>
            <a-alert :message="$t('message.transform.bindCheckSuccess')" type="success" show-icon>
              <p slot="description" style="font-size: 6px">
                <span style="color: black; font-size: 3px"
                >{{$t('message.transform.bindCheckSuccess')}}</span
                >
              </p>
            </a-alert>
          </template>
        </div>
        <div v-if="this.transformCheckBox.status == 3">
          <template>
            <a-alert :message="$t('message.transform.bindCheckFailed')" type="error" show-icon>
              <p slot="description" style="font-size: 6px">
                <span style="color: black; font-size: 3px"
                >{{$t('message.transform.bindCheckFailed')}}</span
                >
                <a
                  v-show="true"
                  :href="this.transformCheckBox.downloadUrl"
                  download="publishTemplate.xlsx"
                >{{$t('message.transform.failDetail')}}</a
                >
              </p>
            </a-alert>
          </template>
        </div>
        <div v-if="this.transformCheckBox.status == 4">
          <template>
            <a-alert :message="$t('emssage.transform.bindCheckException')" type="error" show-icon>
              <p slot="description" style="font-size: 6px">
                <span style="color: black; font-size: 3px"
                >{{$t('message.transform.bindCheckException')}}</span
                >
              </p>
            </a-alert>
          </template>
        </div>
        <a-divider/>
        <div>
          <template>
            <a-timeline>
              <a-timeline-item :color="this.eachStepShow.a.color">
                <p>{{$t('message.transform.shipperCheck')}}</p>
                <!--                <span style="color: grey;font-size: 10px">Jun, 10, 2016 10:30:00</span>-->
              </a-timeline-item>
              <a-timeline-item :color="this.eachStepShow.b.color">
                <p>{{$t('message.transform.itemCheck')}}</p>
                <!--                <span style="color: grey;font-size: 10px">Jun, 10, 2016 10:30:00</span>-->
              </a-timeline-item>
              <a-timeline-item :color="this.eachStepShow.c.color">
                <p></p>
                <p>{{$t('message.transform.orderCheck')}}</p>
                <!--                <span style="color: grey;font-size: 10px">Jun, 10, 2016 10:30:00</span>-->
              </a-timeline-item>
              <a-timeline-item :color="this.eachStepShow.d.color">
                <p>{{$t('message.transform.inventoryCheck')}}</p>
                <!--                <span style="color: grey;font-size: 10px"></span>-->
              </a-timeline-item>
            </a-timeline>
          </template>
        </div>

      </a-modal>
      <a-modal
        :closable="false"
        :title="$t('message.transform.shopBind')"
        :visible="modelShowChange.transform"
        :confirm-loading="confirmLoading"
        :width="830"
        :footer=null
        :maskClosable="false"
      >

        <div v-if="this.transformProcessBox.status==1">
          <template>
            <a-alert :message="$t('message.transform.shopBinding')" type="info">
              <p slot="description" style="font-size: 6px">
                <span style="color: black;font-size: 3px">{{$t('message.transform.shopBindingWaitingMention')}}</span>
              </p>
            </a-alert>
          </template>
          <template>
            <a-result
              :title="$t('message.transform.shopBindingWaitingMention')"
            />
          </template>
        </div>
        <div v-if="this.transformProcessBox.status==2">
          <template>
            <a-alert :message="$t('message.transform.shopBindingSuccess')" type="success">
              <p slot="description" style="font-size: 6px">
                <span style="color: black;font-size: 3px">{{ $t('message.transform.shopBindingSuccess') }}</span>
              </p>
            </a-alert>
          </template>
          <template>
            <a-result
              status="success"
              :title="$t('message.transform.shopBindingSuccess')"
            />
          </template>
        </div>
        <div v-if="this.transformProcessBox.status==3">
          <template>
            <a-alert :message="$t('message.transform.shopBindingFailed')" type="error">
              <p slot="description" style="font-size: 6px">
                <span style="color: black;font-size: 3px">{{ $t('message.transform.shopBindingFailed') }}</span>
                <a v-show="true" :href="this.transformProcessBox.downloadUrl"
                   download="publishTemplate.xlsx">{{ $t('message.transform.shopBindFailedAndDownload') }}</a>
              </p>
            </a-alert>
          </template>
          <template>
            <a-result
              status="error"
              :title="$t('message.transform.shopBindFailedAndDownload')"
            />
          </template>
        </div>
        <div v-if="this.transformProcessBox.status==4">
          <template>
            <a-alert :message="$t('message.transform.shopBindException')" type="error">
              <p slot="description" style="font-size: 6px">
                <span style="color: black;font-size: 3px">{{ $t('message.transform.shopBindException') }}</span>

              </p>
            </a-alert>
          </template>
          <template>
            <a-result
              status="error"
              :title="$t('message.transform.shopBindException')"
            />
          </template>
        </div>
        <a-divider/>
        <a-space>
          <a-button type="primary" html-type="cancel" :style="{display:this.transformButtonShow}"
                    @click="cancelTransforModal">
            ${{$t('message.transform.cancel')}}
          </a-button>
        </a-space>
      </a-modal>
    </div>
  </a-layout-content>

</template>

<script>
import request from '../../utils/request'

const modelButtonProps = {
  props: {disabled: true}
}
const modelCancelButtonProps = {
  props: {disabled: true}
}
export default {

  name: 'OwnerTransfer.vue',
  created () {
    request({
      url: '/shipper/shopInfo',
      method: 'get'
    }).then(response => {
      var result = response.data.data
      this.shopList = []
      result.forEach(n => {
        if (n.platform !== 'AEG') {
          this.shopList.push(n)
        }
      })
    })
    request({
      url: '/bind/latestBindRecord',
      method: 'get'
    }).then(response => {
      var result = response.data.data
      if (result !== '') {
        this.lastBindRecord = result
      }
    })
  },
  mounted () {

  },
  destroyed () {
    clearInterval(this.timer)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  data () {
    return {
      modelShowChange: {check: false, transform: false},
      lastBindRecord: {
        taskId: '',
        vShipperId: '',
        shopNames: [],
        beginTime: '',
        finish: null,
        success: null,
        downloadErrorFileUrl: ''
      },
      eachStepShow: {
        a: {key: 0, color: 'blue'},
        b: {key: 1, color: 'blue'},
        c: {key: 2, color: 'blue'},
        d: {key: 3, color: 'blue'}
      },
      transformButtonShow: 'none',
      transformCheckBox: {
        downloadUrl: '',
        status: 1,
        eachStepStatus: {
          0: 1,
          1: 1,
          2: 1,
          3: 1
        }
      },
      transformProcessBox: {
        downloadUrl: '',
        status: 1
      },
      modelButtonProps,
      modelCancelButtonProps,
      timer: null,
      transformTimer: null,
      ModalText: 'Content of the modal',
      transformButtonValid: true,
      confirmLoading: false,
      shopList: [
        {
          platform: 'LAZADA',
          site: 'MY',
          bizType: 117000,
          groupId: '81042',
          sellerId: '100131295',
          shipperId: '3944706226',
          sellerCode: 'MY136NR',
          shopName: 'MY-Test Lazada CB Shop 03',
          sellerName: 'JimHu',
          cb: false
        },
        {
          platform: 'LAZADA',
          site: 'SG',
          bizType: 117000,
          groupId: '81002',
          sellerId: '100056775',
          shipperId: '3944706226',
          sellerCode: 'SG11RAC',
          shopName: 'SG-Yishion191',
          sellerName: 'Textxbxhxxhh',
          cb: false
        },
        {
          platform: 'LAZADA',
          site: 'ID',
          bizType: 117000,
          groupId: '81032',
          sellerId: '100191757',
          shipperId: '3944706226',
          sellerCode: 'ID15NM4',
          shopName: 'ID-Test Lazada CB Shop 03',
          sellerName: 'Test Test',
          cb: true
        }

      ],
      selectedShopList: [],
      form: this.$form.createForm(this),
      labelCol: {
        xs: {span: 8},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 15},
        sm: {span: 16}
      }
    }
  },
  methods: {
    cancelTransforModal () {
      this.transformButtonShow = 'none'
      this.modelShowChange.check = false
      this.modelShowChange.transform = false
    },
    showModal () {
      this.modelShowChange.check = true
    },
    handleOk (e) {
      this.modelShowChange.check = false
      this.modelShowChange.transform = true
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      var list = this.selectedShopList

      request({
        url: '/bind/transform?sellerCodes=' + list,
        method: 'get'
      }).catch(exception => {
        this.transformProcessBox.status = 4
      }).then(response => {
        if (response.data.success == false) {
          this.transformProcessBox.status = 4
          return
        }
        var result = response.data.data
        this.queryTransformResultByTaskId(result)
      })
    },
    handleCancel (e) {
      this.modelShowChange.check = false
      this.modelCancelButtonProps.props.disabled = true
      this.modelButtonProps.props.disabled = true
      this.eachStepShow = {
        a: {key: 0, color: 'blue'},
        b: {key: 1, color: 'blue'},
        c: {key: 2, color: 'blue'},
        d: {key: 3, color: 'blue'}
      }
      this.transformCheckBox = {
        status: 1,
        eachStepStatus: {
          0: 1,
          1: 1,
          2: 1,
          3: 1
        }
      }
    },
    handleTransformProcessCancel (e) {
      this.modelShowChange.transform = false
      this.modelTransformCancelButtonProps.props.disabled = true
      this.transformProcessBox = {
        downloadUrl: '',
        status: 1,
        eachStepStatus: {
          0: 1,
          1: 1,
          2: 1,
          3: 1
        }
      }
    },
    onChange (e) {
      this.selectedShopList = e
      if (this.selectedShopList.length > 0) {
        this.transformButtonValid = false
      } else {
        this.transformButtonValid = true
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      var list = this.selectedShopList
      this.showModal()

      request({
        url: '/bind/check?sellerCodes=' + list,
        method: 'get'
      }).catch(exception => {
        clearInterval(this.timer)
        this.transformCheckBox.status = 4
      }).then(response => {
        if (response.data.success == false) {
          this.transformCheckBox.status = 4
          return
        }
        var result = response.data.data
        this.queryCheckResultByTaskId(result)
      })
    },
    queryCheckResultByTaskId (taskId) {
      this.timer = setInterval(() => {
        request({
          url: '/bind/status/check?taskId=' + taskId,
          method: 'get'
        }).catch(exception => {
          clearInterval(this.timer)
          this.transformCheckBox.status = 4

          this.timer = null
        }).then(response => {
          if (response.data.success == false) {
            this.transformCheckBox.status = 4
            return
          }
          var result = response.data.data
          // status = 1(进行中)
          // status = 2(成功)
          // status = 3(失败)
          if (result.status == 2 || result.status == 3) {
            clearInterval(this.timer)
            this.transformCheckBox = result
            if (this.eachStepShow.a.key == 0) {
              if (this.transformCheckBox.eachStepStatus['0'] == 1) {
                this.eachStepShow.a.color = 'blue'
              } else if (this.transformCheckBox.eachStepStatus['0'] == 2) {
                this.eachStepShow.a.color = 'green'
              } else if (this.transformCheckBox.eachStepStatus['0'] == 3) {
                this.eachStepShow.a.color = 'red'
              }
            }

            if (this.eachStepShow.b.key == 1) {
              if (this.transformCheckBox.eachStepStatus['1'] == 1) {
                this.eachStepShow.b.color = 'blue'
              } else if (this.transformCheckBox.eachStepStatus['1'] == 2) {
                this.eachStepShow.b.color = 'green'
              } else if (this.transformCheckBox.eachStepStatus['1'] == 3) {
                this.eachStepShow.b.color = 'red'
              }
            }

            if (this.eachStepShow.c.key == 2) {
              if (this.transformCheckBox.eachStepStatus['2'] == 1) {
                this.eachStepShow.c.color = 'blue'
              } else if (this.transformCheckBox.eachStepStatus['2'] == 2) {
                this.eachStepShow.c.color = 'green'
              } else if (this.transformCheckBox.eachStepStatus['2'] == 3) {
                this.eachStepShow.c.color = 'red'
              }
            }

            if (this.eachStepShow.d.key == 3) {
              if (this.transformCheckBox.eachStepStatus['3'] == 1) {
                this.eachStepShow.d.color = 'blue'
              } else if (this.transformCheckBox.eachStepStatus['3'] == 2) {
                this.eachStepShow.d.color = 'green'
              } else if (this.transformCheckBox.eachStepStatus['3'] == 3) {
                this.eachStepShow.d.color = 'red'
              }
            }

            this.modelCancelButtonProps.props.disabled = false
            if (result.status == 2) {
              this.modelButtonProps.props.disabled = false
            }
          }
        })
      }, 5000)
      // 结束释放定时伦轮询
      this.$once('hook:beforeDestroy', function () {
        clearInterval(this.timer)
      })
    },
    queryTransformResultByTaskId (taskId) {
      this.transformTimer = setInterval(() => {
        request({
          url: '/bind/status/transform?taskId=' + taskId,
          method: 'get'
        }).catch(exception => {
          clearInterval(this.transformTimer)
          this.transformProcessBox.status = 4
          this.transformTimer = null
        }).then(response => {
          if (response.data.success == false) {
            this.transformProcessBox.status = 4
            return
          }
          var result = response.data.data
          // status = 1(进行中)
          // status = 2(成功)
          // status = 3(失败)
          if (result.status == 2 || result.status == 3) {
            this.transformProcessBox = result
            clearInterval(this.timer)
            this.transformButtonShow = 'block'
          }
        })
      }, 5000)
      // 结束释放定时伦轮询
      this.$once('hook:beforeDestroy', function () {
        clearInterval(this.transformTimer)
      })
    }
  }
}
</script>

<style scoped>
.ant-progress-circle-wrap,
.ant-progress-line-wrap {
  margin-right: 8px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/authorization/OwnerTransfer.vue